import { useSelector } from 'react-redux';
import { useRoute } from 'hooks/useRoute';
import { getCommonDataLayerVariables } from 'lib/datalayer/selectors/getCommonDataLayerVariables';
import { getPropertyPageDataLayerVariables } from 'lib/datalayer/selectors/getPropertyPageDataLayerVariables';
import { getCheckoutPageDataLayerVariables } from 'lib/datalayer/selectors/getCheckoutPageDataLayerVariables';
import { getConfirmationPageDataLayerVariables } from 'lib/datalayer/selectors/getConfirmationPageDataLayerVariables';
import { getDestinationPageDataLayerVariables } from 'lib/datalayer/selectors/getDestinationPageDataLayerVariables';

const noopSelector = () => ({});

const routeLookup = {
  property: getPropertyPageDataLayerVariables,
  checkout: getCheckoutPageDataLayerVariables,
  'booking-confirmation': getConfirmationPageDataLayerVariables,
  destination: getDestinationPageDataLayerVariables,
};

export const useRouteData = () => {
  const route = useRoute();
  const routeSelector = routeLookup[route?.name] || noopSelector;

  const commonVariables = useSelector(getCommonDataLayerVariables);
  const pageVariables = useSelector(routeSelector);

  return {
    ready: true,
    ...commonVariables,
    ...pageVariables,
  };
};
